import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
  dispStatus: false,
};

const agentDisconnectStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentDisconnectSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    dispStatus: action.status,
    customerDetails:{crmValues:{}, basicValues:{}},
  });
};

const agentDisconnectReset = (state, action) =>{
  return updateObject(state, {dispStatus: ''});
}
const agentDisconnectFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false,});
};

const agentTelDisconnectStart = (state, action) =>{
  return updateObject(state, {loading: true});
}

const agentTelDisconnectSuccess = (state, action) =>{
   return updateObject(state, {loading: false});
}

const agentTelDisconnectFail = (state, action) =>{
   return updateObject(state, {error: action.error, loading: false});

}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_DISCONNECT_START:
      return agentDisconnectStart(state, action);
    case actionTypes.AGENT_DISCONNECT_SUCCESS:
      return agentDisconnectSuccess(state, action);
    case actionTypes.AGENT_DISCONNECT_FAIL:
      return agentDisconnectFail(state, action);
    case actionTypes.AGENT_DISCONNECT_RESET:
         return agentDisconnectReset(state, action);
    case actionTypes.AGENT_TEL_DISCONNECT_START:
        return agentTelDisconnectStart(state, action);
    case actionTypes.AGENT_TEL_DISCONNECT_SUCCESS:
        return agentTelDisconnectSuccess(state, action);
    case actionTypes.AGENT_TEL_DISCONNECT_FAIL:
       return agentTelDisconnectFail(state, action);
    default:
      return state;
  }
};

export default reducer;
